import { render, staticRenderFns } from "./Frequencias.vue?vue&type=template&id=7d1132ac&"
import script from "./Frequencias.vue?vue&type=script&lang=js&"
export * from "./Frequencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports